import ConfigData from '../config.json'
import { Auth } from 'aws-amplify';

const base_url = ConfigData.url

const getFromServer = async (url) => {
    let data = {}
    let status = {}
    console.log(url, " - getFromServer1")
    console.log(base_url, " - getFromServer2")
    console.log(url.startsWith('https:') ? url : (base_url + url), " - getFromServer3")

    try {
        const res = await fetch(
            url.startsWith('https:') ? url : (base_url + url), {
            method: 'get',
            headers: {
                // 'Authorization': token,
                'Content-Type': 'application/json',
            },
            referrerPolicy: 'no-referrer'
        })
        data = await res.json()
        status = res.status
    } catch (error) {
        console.log("FETCH ERROR")
        status = 500
        data = { status: status, detail: "Network error", message: error }
        console.log(data)
    }
    return { data, status }
}

const getSessionToken = async (url) => {
    const session = await Auth.currentSession()
    let accessToken = session.getAccessToken()
    return accessToken.getJwtToken()
}

const getFromServerToken = async (url) => {
    let data = {}
    let status = {}

    const token = await getSessionToken()
    
    console.log(url, " - getToServerToken1")
    console.log(base_url, " - getToServerToken2")
    console.log(url.startsWith('https:') ? url : (base_url + url), " - getToServerToken3")
    try {
        const res = await fetch(
            url.startsWith('https:') ? url : (base_url + url), {
            method: 'get',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
            referrerPolicy: 'no-referrer'
        })
        data = await res.json()
        status = res.status
    } catch (error) {
        console.log("FETCH ERROR")
        status = 500
        data = { status: 500, detail: "Network error", message: error }
        console.log(data)
    }
    return { data, status }
}

const sendToServerToken = async (url, body, method) => {
    let data = {}
    let status = 0

    console.log(url, " - sendToServerToken1")
    console.log(base_url, " - sendToServerToken2")
    console.log(url.startsWith('https:') ? url : (base_url + url), " - sendToServerToken3")

    const token = await getSessionToken()
    try {
        const res = await fetch(
            url.startsWith('https:') ? url :(base_url + url), {
            method: method,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            },
            referrerPolicy: 'no-referrer',
            body: body
        })
        data = await res.json()
        status = res.status
    } catch (error) {
        console.log("FETCH ERROR")
        status = 500
        data = { status: 500, detail: "Network error", message: error }
        console.log(data)
    }
    return { data, status }
}

const postToServerToken = async (url, body) => {
    return await sendToServerToken(url, body, "POST")
}

const patchToServerToken = async (url, body) => {
    return await sendToServerToken(url, body, "PATCH")
}

const deleteFromServerToken = async (url) => {
    return await sendToServerToken(url, null, "DELETE")
}

export { getFromServer, getFromServerToken, postToServerToken, patchToServerToken,  deleteFromServerToken}